import React from "react";
import i18n from "../lib/i18n";
import Dropdown from "react-bootstrap/Dropdown";

import { STATUS_OPTIONS } from "../lib/maintenance_plan_action";

const STATUSES = ["unchanged"].concat(STATUS_OPTIONS.map((item) => item.value));

const StatusPicker = ({ currentStatus, disabled, exclude = [], onSelect }) => {
  let renderStatuses = STATUSES.filter((status) => !exclude.includes(status));

  return (
    <div className="btn-group">
      <Dropdown
        style={{ display: "inline-block" }}
        className="status"
        data-testid="status-picker"
      >
        <Dropdown.Toggle
          variant="secondary"
          size="sm"
          id="dropdown-basic"
          disabled={disabled}
          className={`form-control ${currentStatus}`}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span style={{ display: "inline-block", flexGrow: 1 }}>
              {getStatusLabel(currentStatus)}
            </span>

            {!disabled && (
              <span
                className="caret"
                style={{ display: "inline-block", marginLeft: "3px" }}
              />
            )}
          </div>
        </Dropdown.Toggle>

        <Dropdown.Menu
          as="ul"
          popperConfig={{ strategy: "fixed" }}
          renderOnMount
        >
          {renderStatuses.map((status) => (
            <StatusItem key={status} status={status} onSelect={onSelect} />
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

const StatusItem = ({ onSelect, status }) => {
  return (
    <Dropdown.Item as="li">
      <a className={status} onClick={() => onSelect(status)}>
        {getStatusLabel(status)}
      </a>
    </Dropdown.Item>
  );
};

const getStatusLabel = (status) => {
  if (status == "unchanged") {
    return i18n.t("js.components.status_picker.unchanged");
  }

  const item = STATUS_OPTIONS.find((option) => option.value == status);
  if (item) {
    return item.label;
  }

  return i18n.t("js.components.status_picker.unknown");
};

export default StatusPicker;
